/*
*###############################################################################
*Module Name                   : DPPrintOptions.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Monday, December 6th 2021, 8:57:09 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Container, img, CardText } from "reactstrap"
import imageExcelDownload from "assets/images/Download.png"
import imagePDFDownload from "assets/images/pdf.png"
// import images
import profile from "assets/images/profile-img.png"
import Logo from "assets/images/logo/Logo.png"
import avatar from "assets/images/users/uac-shield.png"
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import DPTextBox from 'framework/components/DPTextBox';
import { Text } from 'framework/validators/TextValidation';

const DPPrintOption = ({ confirm_both, title, description, onConfirmxcel, onCancel, onConfirmpdf, showCancel, btnColor, cancelColor, btnYes, btnNo,
    AlName, AlNameOnchange, AlPassward, AlPasswardOnchange, AlReason, AlReasonOnchange, showReason, nameDisable, pdfOnly = false, excelOnly = false }) => {

    let htmlTitle = <h3 style={{ color: "#2A3042" }}>{title}</h3>
    const [AcceptDisable, setAcceptDisable] = useState(false)
    const desc = "Please select the File Format.."
    let htmlMessage = <h5 style={{ color: "#2A3042" }}>{desc}</h5>

    useEffect(() => {
        if (showReason == true) {
            if (AlReason == "") {
                setAcceptDisable(true)
            }
            else if (AlReason != "") {
                setAcceptDisable(false)
            }
        } else { setAcceptDisable(false) }
    })
    return (
        <div>
            {confirm_both ? (
                <SweetAlert
                    title={""}
                    custom
                    customIcon={""}
                    onConfirm={() => { }}
                    showCancel={showCancel}
                    confirmBtnBsStyle={btnColor}
                    cancelBtnBsStyle={cancelColor}
                    onConfirmpdf={onConfirmpdf}
                    onConfirmxcel={onConfirmxcel}
                    onCancel={onCancel}
                    closeOnClickOutside={false}
                    customButtons={
                        <Row>

                            <Col>
                                {showCancel ? <Button color={cancelColor} size="lg" onClick={onCancel} >{btnNo ? btnNo : 'Cancel'}</Button> : ''}
                            </Col>
                        </Row>
                    } >
                    <React.Fragment>
                        <Row>
                            <Col sm="12" >
                                <Row>
                                    {htmlTitle}
                                </Row>
                            </Col>
                        </Row>

                        <Row className='mb-3 mt-3' style={{ alignContent: "center", fontSize: 14, color: "#2A3042", textAlign: "justify" }}>
                            {htmlMessage}
                            <br />

                            {' '}
                        </Row>
                        <Row>

                            <Col>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm="12">
                                                <CardText className="mb-0">
                                                    {pdfOnly ?
                                                        <Row>
                                                            <Col sm={12} md={12} className="mb-4-sm">
                                                                <Button color={btnColor} size="lg" style={{ width: "100px", height: "80px" }} onClick={onConfirmpdf} >
                                                                    <img src={imagePDFDownload} style={{ width: "40px", height: "40px" }}></img>
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        : excelOnly ?
                                                            <Row>
                                                                <Col sm={12} md={12} className="mb-4-sm">
                                                                    <li className="import-export-button" style={{ display: "block" }}>
                                                                        <Button color={btnColor} size="lg" style={{ width: "100px", height: "80px" }} onClick={onConfirmxcel} >
                                                                            <img src={imageExcelDownload} style={{ width: "40px", height: "40px" }}></img></Button>
                                                                    </li>
                                                                </Col>
                                                            </Row>
                                                            :
                                                            <Row>
                                                                <Col sm={12} md={6} className="mb-4-sm">
                                                                    <li className="import-export-button" style={{ display: "block" }}>
                                                                        <Button color={btnColor} size="lg" style={{ width: "100px", height: "80px" }} onClick={onConfirmxcel} >
                                                                            <img src={imageExcelDownload} style={{ width: "40px", height: "40px" }}></img></Button>
                                                                    </li>
                                                                </Col>

                                                                <Col sm={12} md={6} className="mb-4-sm">
                                                                    <Button color={btnColor} size="lg" style={{ width: "100px", height: "80px" }} onClick={onConfirmpdf} >
                                                                        <img src={imagePDFDownload} style={{ width: "40px", height: "40px" }}></img>
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                    }

                                                </CardText>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </React.Fragment>

                </SweetAlert>
            ) : null}
        </div>
    );
}
export default DPPrintOption;